class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    // close results with escape (without bubbling so e.g. drawers stay open)
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen()) {
        event.stopPropagation();
        this.close();
      }
    });

    // close results when tapping/clicking outside the search component
    document.addEventListener('click', (event) => {
      if (this.isOpen() && !this.contains(event.target)) {
        this.close();
      }
    });

    // re-open existing results when the input regains focus
    this.input.addEventListener('focus', () => {
      if (this.input.value.trim().length && this.predictiveSearchResults.innerHTML.trim().length) {
        this.open();
      }
    });
  }

  isOpen() {
    return this.predictiveSearchResults && this.predictiveSearchResults.style.display === 'block';
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);